/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CurriculumInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class CurriculumApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Curricula');
  }

  publishForLearningArea(learningAreaId: number): Observable<CurriculumInterface> {
    const path = `publish-for-learningarea/${learningAreaId}`;
    return this.get<CurriculumInterface>(path, undefined);
  }
}
